<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-info" v-if="hasNoGPSDevices">
      No GPS devices added for this WeHunt GPS.
    </div>

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <table class="table is-fullwidth is-striped" v-if="!isLoading && !hasNoGPSDevices">
      <thead>
        <tr>
          <th></th>
          <th>Owner</th>
          <th>Id</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="gpsDevice in gpsDevices" :key="gpsDevice.deviceId">
          <td>
            <button
              class="button is-text is-size-6 has-text-danger"
              @click="deleteGPSDevice(gpsDevice)"
            >
              Delete
            </button>
          </td>

          <td>
            <span v-if="gpsOwnerUser(gpsDevice.ownerUserId)"
              >{{ gpsOwnerUser(gpsDevice.ownerUserId).email }} ({{
                gpsOwnerUser(gpsDevice.ownerUserId).firstName
              }}
              {{ gpsOwnerUser(gpsDevice.ownerUserId).lastName }})</span
            >
          </td>

          <td>
            <a @click="gpsDeviceSelected(gpsDevice)">{{ gpsDevice.deviceId }}_GPS</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Spinner from '@/components/utils/Spinner'

import {
  LOAD_GPS_DEVICES,
  IS_LOADING_GPS_DEVICES,
  GET_GPS_DEVICES,
  GET_GPS_DEVICES_LOAD_ERROR
} from './weHuntGPSStore'

import { LOAD_USERS_WITH_IDS, GET_USER_WITH_ID } from '@/modules/users/usersCacheStore.js'

export default {
  name: 'WeHuntGPSDevicesTab',

  components: {
    Spinner
  },

  props: {
    weHuntGPSStorePath: {
      type: String,
      required: true
    },
    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  mounted() {
    this.loadGPSDevices()
    this.loadOwnerUsers()
  },

  computed: {
    isLoading() {
      const isLoadingGPSDevices = `${this.weHuntGPSStorePath}/${IS_LOADING_GPS_DEVICES}`
      return this.$store.getters[isLoadingGPSDevices]
    },

    hasNoGPSDevices() {
      const getGPSDevices = `${this.weHuntGPSStorePath}/${GET_GPS_DEVICES}`
      const gpsDevices = this.$store.getters[getGPSDevices]

      if (!gpsDevices) {
        return false
      }

      return gpsDevices.length === 0
    },

    gpsDevices() {
      const getGPSDevices = `${this.weHuntGPSStorePath}/${GET_GPS_DEVICES}`
      return this.$store.getters[getGPSDevices]
    },

    loadError() {
      const getGPSDevicesLoadError = `${this.weHuntGPSStorePath}/${GET_GPS_DEVICES_LOAD_ERROR}`
      return this.$store.getters[getGPSDevicesLoadError]
    }
  },

  methods: {
    loadGPSDevices() {
      const loadGPSDevicesAction = `${this.weHuntGPSStorePath}/${LOAD_GPS_DEVICES}`
      this.$store.dispatch(loadGPSDevicesAction)
    },

    loadOwnerUsers() {
      if (!this.gpsDevices) {
        return
      }

      const loadUserWithIdsAction = `${this.usersCacheStorePath}/${LOAD_USERS_WITH_IDS}`
      const userIds = this.gpsDevices.map(gpsDevice => gpsDevice.ownerUserId)
      this.$store.dispatch(loadUserWithIdsAction, { userIds })
    },

    gpsOwnerUser(userId) {
      const getUserWithIdPath = `${this.usersCacheStorePath}/${GET_USER_WITH_ID}`
      return this.$store.getters[getUserWithIdPath](userId)
    },

    deleteGPSDevice(gpsDevice) {
      this.$emit('delete-gps-device', gpsDevice)
    },

    gpsDeviceSelected(gpsDevice) {
      this.$emit('gps-device-selected', gpsDevice)
    }
  },

  watch: {
    gpsDevices() {
      this.loadOwnerUsers()
    }
  }
}
</script>

<style lang="scss" scoped>
.table td {
  border-bottom: 0;
}

td span {
  white-space: nowrap;
}

td .button {
  padding: 0px;
  height: 1.5em;
}
</style>
